import Form, { FormField } from '@thinknimble/tn-forms'

export class ImageForm extends Form {
  static imageUrl = new FormField()
  static imageTitle = new FormField()
  static imageAlt = new FormField()
}
